import * as React from 'react'

type ActionFormProps = {
  hiddenInputs?: { [key: string]: string },
  method?: 'GET' | 'POST',
  children?: React.ReactNode,
  [param: string]: any, // TODO
}
export const ActionForm = ({
  hiddenInputs = {},
  method = 'POST',
  children,
  ...otherProps
}: ActionFormProps) => (
  <form {...otherProps} method={method} >
    {children}
    {Object.keys(hiddenInputs).map((name, idx) =>
      <input key={`ActionFormInput-${idx}`} type="hidden" name={name} value={hiddenInputs[name]} />)
    }
  </form>
)